/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * Dev API
 * OpenAPI spec version: 0.0.1
 */
import type {
  AvatarListResponseResponse,
  AvatarPatchRequestBodyBody,
  AvatarRequestBodyBody,
  AvatarResponseResponse,
  CategoryListResponseResponse,
  CategoryPatchRequestBodyBody,
  CategoryRequestBodyBody,
  CategoryResponseResponse,
  CreateAvatarParams,
  CreateCategoryParams,
  CreateIconParams,
  CreateImageParams,
  CreateMemberParams,
  CreateModelParams,
  CreatePayloadKvParams,
  CreatePayloadLockedDocumentParams,
  CreatePayloadMigrationParams,
  CreatePayloadPreferenceParams,
  CreatePhotoParams,
  CreatePremiumSubscriptionParams,
  CreateStatsParams,
  CreateTagParams,
  CreateTokenUtilityParams,
  CreateUserParams,
  DeleteAvatarParams,
  DeleteCategoryParams,
  DeleteIconParams,
  DeleteImageParams,
  DeleteMemberParams,
  DeleteModelParams,
  DeletePayloadKvParams,
  DeletePayloadLockedDocumentParams,
  DeletePayloadMigrationParams,
  DeletePayloadPreferenceParams,
  DeletePhotoParams,
  DeletePremiumSubscriptionParams,
  DeleteStatsParams,
  DeleteTagParams,
  DeleteTokenUtilityParams,
  DeleteUserParams,
  FindAvatarByIdParams,
  FindCategoryByIdParams,
  FindIconByIdParams,
  FindImageByIdParams,
  FindMemberByIdParams,
  FindModelByIdParams,
  FindPayloadKvByIdParams,
  FindPayloadLockedDocumentByIdParams,
  FindPayloadMigrationByIdParams,
  FindPayloadPreferenceByIdParams,
  FindPhotoByIdParams,
  FindPremiumSubscriptionByIdParams,
  FindStatsByIdParams,
  FindTagByIdParams,
  FindTokenUtilityByIdParams,
  FindUserByIdParams,
  GetApiGlobalsSettingsParams,
  IconListResponseResponse,
  IconPatchRequestBodyBody,
  IconRequestBodyBody,
  IconResponseResponse,
  ImageListResponseResponse,
  ImagePatchRequestBodyBody,
  ImageRequestBodyBody,
  ImageResponseResponse,
  ListAvatarsParams,
  ListCategoriesParams,
  ListIconsParams,
  ListImagesParams,
  ListMembersParams,
  ListModelsParams,
  ListPayloadKvsParams,
  ListPayloadLockedDocumentsParams,
  ListPayloadMigrationsParams,
  ListPayloadPreferencesParams,
  ListPhotosParams,
  ListPremiumSubscriptionsParams,
  ListStatsParams,
  ListTagsParams,
  ListTokenUtilitiesParams,
  ListUsersParams,
  MemberListResponseResponse,
  MemberPatchRequestBodyBody,
  MemberRequestBodyBody,
  MemberResponseResponse,
  ModelListResponseResponse,
  ModelPatchRequestBodyBody,
  ModelRequestBodyBody,
  ModelResponseResponse,
  NewAvatarResponseResponse,
  NewCategoryResponseResponse,
  NewIconResponseResponse,
  NewImageResponseResponse,
  NewMemberResponseResponse,
  NewModelResponseResponse,
  NewPayloadKvResponseResponse,
  NewPayloadLockedDocumentResponseResponse,
  NewPayloadMigrationResponseResponse,
  NewPayloadPreferenceResponseResponse,
  NewPhotoResponseResponse,
  NewPremiumSubscriptionResponseResponse,
  NewStatsResponseResponse,
  NewTagResponseResponse,
  NewTokenUtilityResponseResponse,
  NewUserResponseResponse,
  PayloadKvListResponseResponse,
  PayloadKvPatchRequestBodyBody,
  PayloadKvRequestBodyBody,
  PayloadKvResponseResponse,
  PayloadLockedDocumentListResponseResponse,
  PayloadLockedDocumentPatchRequestBodyBody,
  PayloadLockedDocumentRequestBodyBody,
  PayloadLockedDocumentResponseResponse,
  PayloadMigrationListResponseResponse,
  PayloadMigrationPatchRequestBodyBody,
  PayloadMigrationRequestBodyBody,
  PayloadMigrationResponseResponse,
  PayloadPreferenceListResponseResponse,
  PayloadPreferencePatchRequestBodyBody,
  PayloadPreferenceRequestBodyBody,
  PayloadPreferenceResponseResponse,
  PhotoListResponseResponse,
  PhotoPatchRequestBodyBody,
  PhotoRequestBodyBody,
  PhotoResponseResponse,
  PremiumSubscriptionListResponseResponse,
  PremiumSubscriptionPatchRequestBodyBody,
  PremiumSubscriptionRequestBodyBody,
  PremiumSubscriptionResponseResponse,
  SettingsRequestBodyBody,
  SettingsResponseResponse,
  StatsListResponseResponse,
  StatsPatchRequestBodyBody,
  StatsRequestBodyBody,
  StatsResponseResponse,
  TagListResponseResponse,
  TagPatchRequestBodyBody,
  TagRequestBodyBody,
  TagResponseResponse,
  TokenUtilityListResponseResponse,
  TokenUtilityPatchRequestBodyBody,
  TokenUtilityRequestBodyBody,
  TokenUtilityResponseResponse,
  UpdateAvatarParams,
  UpdateCategoryParams,
  UpdateIconParams,
  UpdateImageParams,
  UpdateMemberParams,
  UpdateModelParams,
  UpdatePayloadKvParams,
  UpdatePayloadLockedDocumentParams,
  UpdatePayloadMigrationParams,
  UpdatePayloadPreferenceParams,
  UpdatePhotoParams,
  UpdatePremiumSubscriptionParams,
  UpdateStatsParams,
  UpdateTagParams,
  UpdateTokenUtilityParams,
  UpdateUserParams,
  UserListResponseResponse,
  UserPatchRequestBodyBody,
  UserRequestBodyBody,
  UserResponseResponse
} from '../_models'
import { apiClient } from '../base';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


  /**
 * @summary Retrieve a list of Avatars
 */
export const listAvatars = (
    params?: ListAvatarsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<AvatarListResponseResponse>(
      {url: `/api/userAvatars`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Avatar
 */
export const createAvatar = (
    avatarRequestBodyBody: AvatarRequestBodyBody,
    params?: CreateAvatarParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewAvatarResponseResponse>(
      {url: `/api/userAvatars`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: avatarRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Avatar by ID
 */
export const findAvatarById = (
    id: string,
    params?: FindAvatarByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<AvatarResponseResponse>(
      {url: `/api/userAvatars/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Avatar
 */
export const updateAvatar = (
    id: string,
    avatarPatchRequestBodyBody: AvatarPatchRequestBodyBody,
    params?: UpdateAvatarParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<AvatarResponseResponse>(
      {url: `/api/userAvatars/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: avatarPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Avatar
 */
export const deleteAvatar = (
    id: string,
    params?: DeleteAvatarParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<AvatarResponseResponse>(
      {url: `/api/userAvatars/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Users
 */
export const listUsers = (
    params?: ListUsersParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<UserListResponseResponse>(
      {url: `/api/users`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new User
 */
export const createUser = (
    userRequestBodyBody: UserRequestBodyBody,
    params?: CreateUserParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewUserResponseResponse>(
      {url: `/api/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a User by ID
 */
export const findUserById = (
    id: string,
    params?: FindUserByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<UserResponseResponse>(
      {url: `/api/users/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a User
 */
export const updateUser = (
    id: string,
    userPatchRequestBodyBody: UserPatchRequestBodyBody,
    params?: UpdateUserParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<UserResponseResponse>(
      {url: `/api/users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a User
 */
export const deleteUser = (
    id: string,
    params?: DeleteUserParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<UserResponseResponse>(
      {url: `/api/users/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Categories
 */
export const listCategories = (
    params?: ListCategoriesParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<CategoryListResponseResponse>(
      {url: `/api/modelCategories`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Category
 */
export const createCategory = (
    categoryRequestBodyBody: CategoryRequestBodyBody,
    params?: CreateCategoryParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewCategoryResponseResponse>(
      {url: `/api/modelCategories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: categoryRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Category by ID
 */
export const findCategoryById = (
    id: string,
    params?: FindCategoryByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<CategoryResponseResponse>(
      {url: `/api/modelCategories/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Category
 */
export const updateCategory = (
    id: string,
    categoryPatchRequestBodyBody: CategoryPatchRequestBodyBody,
    params?: UpdateCategoryParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<CategoryResponseResponse>(
      {url: `/api/modelCategories/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: categoryPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Category
 */
export const deleteCategory = (
    id: string,
    params?: DeleteCategoryParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<CategoryResponseResponse>(
      {url: `/api/modelCategories/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Tags
 */
export const listTags = (
    params?: ListTagsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<TagListResponseResponse>(
      {url: `/api/modelTags`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Tag
 */
export const createTag = (
    tagRequestBodyBody: TagRequestBodyBody,
    params?: CreateTagParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewTagResponseResponse>(
      {url: `/api/modelTags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Tag by ID
 */
export const findTagById = (
    id: string,
    params?: FindTagByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<TagResponseResponse>(
      {url: `/api/modelTags/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Tag
 */
export const updateTag = (
    id: string,
    tagPatchRequestBodyBody: TagPatchRequestBodyBody,
    params?: UpdateTagParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<TagResponseResponse>(
      {url: `/api/modelTags/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tagPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Tag
 */
export const deleteTag = (
    id: string,
    params?: DeleteTagParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<TagResponseResponse>(
      {url: `/api/modelTags/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Images
 */
export const listImages = (
    params?: ListImagesParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<ImageListResponseResponse>(
      {url: `/api/modelImages`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Image
 */
export const createImage = (
    imageRequestBodyBody: ImageRequestBodyBody,
    params?: CreateImageParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewImageResponseResponse>(
      {url: `/api/modelImages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: imageRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Image by ID
 */
export const findImageById = (
    id: string,
    params?: FindImageByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<ImageResponseResponse>(
      {url: `/api/modelImages/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Image
 */
export const updateImage = (
    id: string,
    imagePatchRequestBodyBody: ImagePatchRequestBodyBody,
    params?: UpdateImageParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<ImageResponseResponse>(
      {url: `/api/modelImages/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: imagePatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Image
 */
export const deleteImage = (
    id: string,
    params?: DeleteImageParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<ImageResponseResponse>(
      {url: `/api/modelImages/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Models
 */
export const listModels = (
    params?: ListModelsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<ModelListResponseResponse>(
      {url: `/api/models`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Model
 */
export const createModel = (
    modelRequestBodyBody: ModelRequestBodyBody,
    params?: CreateModelParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewModelResponseResponse>(
      {url: `/api/models`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Model by ID
 */
export const findModelById = (
    id: string,
    params?: FindModelByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<ModelResponseResponse>(
      {url: `/api/models/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Model
 */
export const updateModel = (
    id: string,
    modelPatchRequestBodyBody: ModelPatchRequestBodyBody,
    params?: UpdateModelParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<ModelResponseResponse>(
      {url: `/api/models/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: modelPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Model
 */
export const deleteModel = (
    id: string,
    params?: DeleteModelParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<ModelResponseResponse>(
      {url: `/api/models/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Icons
 */
export const listIcons = (
    params?: ListIconsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<IconListResponseResponse>(
      {url: `/api/communityStatsImages`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Icon
 */
export const createIcon = (
    iconRequestBodyBody: IconRequestBodyBody,
    params?: CreateIconParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewIconResponseResponse>(
      {url: `/api/communityStatsImages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: iconRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Icon by ID
 */
export const findIconById = (
    id: string,
    params?: FindIconByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<IconResponseResponse>(
      {url: `/api/communityStatsImages/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Icon
 */
export const updateIcon = (
    id: string,
    iconPatchRequestBodyBody: IconPatchRequestBodyBody,
    params?: UpdateIconParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<IconResponseResponse>(
      {url: `/api/communityStatsImages/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: iconPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Icon
 */
export const deleteIcon = (
    id: string,
    params?: DeleteIconParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<IconResponseResponse>(
      {url: `/api/communityStatsImages/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Stats
 */
export const listStats = (
    params?: ListStatsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<StatsListResponseResponse>(
      {url: `/api/communityStats`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Stats
 */
export const createStats = (
    statsRequestBodyBody: StatsRequestBodyBody,
    params?: CreateStatsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewStatsResponseResponse>(
      {url: `/api/communityStats`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: statsRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Stats by ID
 */
export const findStatsById = (
    id: string,
    params?: FindStatsByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<StatsResponseResponse>(
      {url: `/api/communityStats/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Stats
 */
export const updateStats = (
    id: string,
    statsPatchRequestBodyBody: StatsPatchRequestBodyBody,
    params?: UpdateStatsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<StatsResponseResponse>(
      {url: `/api/communityStats/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: statsPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Stats
 */
export const deleteStats = (
    id: string,
    params?: DeleteStatsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<StatsResponseResponse>(
      {url: `/api/communityStats/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Photos
 */
export const listPhotos = (
    params?: ListPhotosParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PhotoListResponseResponse>(
      {url: `/api/teamMembersImages`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Photo
 */
export const createPhoto = (
    photoRequestBodyBody: PhotoRequestBodyBody,
    params?: CreatePhotoParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewPhotoResponseResponse>(
      {url: `/api/teamMembersImages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: photoRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Photo by ID
 */
export const findPhotoById = (
    id: string,
    params?: FindPhotoByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PhotoResponseResponse>(
      {url: `/api/teamMembersImages/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Photo
 */
export const updatePhoto = (
    id: string,
    photoPatchRequestBodyBody: PhotoPatchRequestBodyBody,
    params?: UpdatePhotoParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PhotoResponseResponse>(
      {url: `/api/teamMembersImages/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: photoPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Photo
 */
export const deletePhoto = (
    id: string,
    params?: DeletePhotoParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PhotoResponseResponse>(
      {url: `/api/teamMembersImages/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Members
 */
export const listMembers = (
    params?: ListMembersParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<MemberListResponseResponse>(
      {url: `/api/teamMembers`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Member
 */
export const createMember = (
    memberRequestBodyBody: MemberRequestBodyBody,
    params?: CreateMemberParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewMemberResponseResponse>(
      {url: `/api/teamMembers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: memberRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Member by ID
 */
export const findMemberById = (
    id: string,
    params?: FindMemberByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<MemberResponseResponse>(
      {url: `/api/teamMembers/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Member
 */
export const updateMember = (
    id: string,
    memberPatchRequestBodyBody: MemberPatchRequestBodyBody,
    params?: UpdateMemberParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<MemberResponseResponse>(
      {url: `/api/teamMembers/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: memberPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Member
 */
export const deleteMember = (
    id: string,
    params?: DeleteMemberParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<MemberResponseResponse>(
      {url: `/api/teamMembers/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Token Utilities
 */
export const listTokenUtilities = (
    params?: ListTokenUtilitiesParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<TokenUtilityListResponseResponse>(
      {url: `/api/tokenUtility`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Token Utility
 */
export const createTokenUtility = (
    tokenUtilityRequestBodyBody: TokenUtilityRequestBodyBody,
    params?: CreateTokenUtilityParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewTokenUtilityResponseResponse>(
      {url: `/api/tokenUtility`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tokenUtilityRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Token Utility by ID
 */
export const findTokenUtilityById = (
    id: string,
    params?: FindTokenUtilityByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<TokenUtilityResponseResponse>(
      {url: `/api/tokenUtility/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Token Utility
 */
export const updateTokenUtility = (
    id: string,
    tokenUtilityPatchRequestBodyBody: TokenUtilityPatchRequestBodyBody,
    params?: UpdateTokenUtilityParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<TokenUtilityResponseResponse>(
      {url: `/api/tokenUtility/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tokenUtilityPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Token Utility
 */
export const deleteTokenUtility = (
    id: string,
    params?: DeleteTokenUtilityParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<TokenUtilityResponseResponse>(
      {url: `/api/tokenUtility/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Premium Subscriptions
 */
export const listPremiumSubscriptions = (
    params?: ListPremiumSubscriptionsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PremiumSubscriptionListResponseResponse>(
      {url: `/api/premiumSubscriptions`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Premium Subscription
 */
export const createPremiumSubscription = (
    premiumSubscriptionRequestBodyBody: PremiumSubscriptionRequestBodyBody,
    params?: CreatePremiumSubscriptionParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewPremiumSubscriptionResponseResponse>(
      {url: `/api/premiumSubscriptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: premiumSubscriptionRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Premium Subscription by ID
 */
export const findPremiumSubscriptionById = (
    id: string,
    params?: FindPremiumSubscriptionByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PremiumSubscriptionResponseResponse>(
      {url: `/api/premiumSubscriptions/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Premium Subscription
 */
export const updatePremiumSubscription = (
    id: string,
    premiumSubscriptionPatchRequestBodyBody: PremiumSubscriptionPatchRequestBodyBody,
    params?: UpdatePremiumSubscriptionParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PremiumSubscriptionResponseResponse>(
      {url: `/api/premiumSubscriptions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: premiumSubscriptionPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Premium Subscription
 */
export const deletePremiumSubscription = (
    id: string,
    params?: DeletePremiumSubscriptionParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PremiumSubscriptionResponseResponse>(
      {url: `/api/premiumSubscriptions/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Payload Kvs
 */
export const listPayloadKvs = (
    params?: ListPayloadKvsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadKvListResponseResponse>(
      {url: `/api/payload-kv`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Payload Kv
 */
export const createPayloadKv = (
    payloadKvRequestBodyBody: PayloadKvRequestBodyBody,
    params?: CreatePayloadKvParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewPayloadKvResponseResponse>(
      {url: `/api/payload-kv`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payloadKvRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Payload Kv by ID
 */
export const findPayloadKvById = (
    id: string,
    params?: FindPayloadKvByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadKvResponseResponse>(
      {url: `/api/payload-kv/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Payload Kv
 */
export const updatePayloadKv = (
    id: string,
    payloadKvPatchRequestBodyBody: PayloadKvPatchRequestBodyBody,
    params?: UpdatePayloadKvParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadKvResponseResponse>(
      {url: `/api/payload-kv/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payloadKvPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Payload Kv
 */
export const deletePayloadKv = (
    id: string,
    params?: DeletePayloadKvParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadKvResponseResponse>(
      {url: `/api/payload-kv/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Payload Locked Documents
 */
export const listPayloadLockedDocuments = (
    params?: ListPayloadLockedDocumentsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadLockedDocumentListResponseResponse>(
      {url: `/api/payload-locked-documents`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Payload Locked Document
 */
export const createPayloadLockedDocument = (
    payloadLockedDocumentRequestBodyBody: PayloadLockedDocumentRequestBodyBody,
    params?: CreatePayloadLockedDocumentParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewPayloadLockedDocumentResponseResponse>(
      {url: `/api/payload-locked-documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payloadLockedDocumentRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Payload Locked Document by ID
 */
export const findPayloadLockedDocumentById = (
    id: string,
    params?: FindPayloadLockedDocumentByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadLockedDocumentResponseResponse>(
      {url: `/api/payload-locked-documents/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Payload Locked Document
 */
export const updatePayloadLockedDocument = (
    id: string,
    payloadLockedDocumentPatchRequestBodyBody: PayloadLockedDocumentPatchRequestBodyBody,
    params?: UpdatePayloadLockedDocumentParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadLockedDocumentResponseResponse>(
      {url: `/api/payload-locked-documents/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payloadLockedDocumentPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Payload Locked Document
 */
export const deletePayloadLockedDocument = (
    id: string,
    params?: DeletePayloadLockedDocumentParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadLockedDocumentResponseResponse>(
      {url: `/api/payload-locked-documents/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Payload Preferences
 */
export const listPayloadPreferences = (
    params?: ListPayloadPreferencesParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadPreferenceListResponseResponse>(
      {url: `/api/payload-preferences`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Payload Preference
 */
export const createPayloadPreference = (
    payloadPreferenceRequestBodyBody: PayloadPreferenceRequestBodyBody,
    params?: CreatePayloadPreferenceParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewPayloadPreferenceResponseResponse>(
      {url: `/api/payload-preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payloadPreferenceRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Payload Preference by ID
 */
export const findPayloadPreferenceById = (
    id: string,
    params?: FindPayloadPreferenceByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadPreferenceResponseResponse>(
      {url: `/api/payload-preferences/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Payload Preference
 */
export const updatePayloadPreference = (
    id: string,
    payloadPreferencePatchRequestBodyBody: PayloadPreferencePatchRequestBodyBody,
    params?: UpdatePayloadPreferenceParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadPreferenceResponseResponse>(
      {url: `/api/payload-preferences/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payloadPreferencePatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Payload Preference
 */
export const deletePayloadPreference = (
    id: string,
    params?: DeletePayloadPreferenceParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadPreferenceResponseResponse>(
      {url: `/api/payload-preferences/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Retrieve a list of Payload Migrations
 */
export const listPayloadMigrations = (
    params?: ListPayloadMigrationsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadMigrationListResponseResponse>(
      {url: `/api/payload-migrations`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new Payload Migration
 */
export const createPayloadMigration = (
    payloadMigrationRequestBodyBody: PayloadMigrationRequestBodyBody,
    params?: CreatePayloadMigrationParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<NewPayloadMigrationResponseResponse>(
      {url: `/api/payload-migrations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payloadMigrationRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Find a Payload Migration by ID
 */
export const findPayloadMigrationById = (
    id: string,
    params?: FindPayloadMigrationByIdParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadMigrationResponseResponse>(
      {url: `/api/payload-migrations/${id}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a Payload Migration
 */
export const updatePayloadMigration = (
    id: string,
    payloadMigrationPatchRequestBodyBody: PayloadMigrationPatchRequestBodyBody,
    params?: UpdatePayloadMigrationParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadMigrationResponseResponse>(
      {url: `/api/payload-migrations/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payloadMigrationPatchRequestBodyBody,
        params
    },
      options);
    }
  
/**
 * @summary Delete a Payload Migration
 */
export const deletePayloadMigration = (
    id: string,
    params?: DeletePayloadMigrationParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<PayloadMigrationResponseResponse>(
      {url: `/api/payload-migrations/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Get the Settings
 */
export const getApiGlobalsSettings = (
    params?: GetApiGlobalsSettingsParams,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<SettingsResponseResponse>(
      {url: `/api/globals/settings`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update the Settings
 */
export const postApiGlobalsSettings = (
    settingsRequestBodyBody: SettingsRequestBodyBody,
 options?: SecondParameter<typeof apiClient>,) => {
      return apiClient<SettingsResponseResponse>(
      {url: `/api/globals/settings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: settingsRequestBodyBody
    },
      options);
    }
  
export type ListAvatarsResult = NonNullable<Awaited<ReturnType<typeof listAvatars>>>
export type CreateAvatarResult = NonNullable<Awaited<ReturnType<typeof createAvatar>>>
export type FindAvatarByIdResult = NonNullable<Awaited<ReturnType<typeof findAvatarById>>>
export type UpdateAvatarResult = NonNullable<Awaited<ReturnType<typeof updateAvatar>>>
export type DeleteAvatarResult = NonNullable<Awaited<ReturnType<typeof deleteAvatar>>>
export type ListUsersResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type CreateUserResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
export type FindUserByIdResult = NonNullable<Awaited<ReturnType<typeof findUserById>>>
export type UpdateUserResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
export type DeleteUserResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
export type ListCategoriesResult = NonNullable<Awaited<ReturnType<typeof listCategories>>>
export type CreateCategoryResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>
export type FindCategoryByIdResult = NonNullable<Awaited<ReturnType<typeof findCategoryById>>>
export type UpdateCategoryResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>
export type DeleteCategoryResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>
export type ListTagsResult = NonNullable<Awaited<ReturnType<typeof listTags>>>
export type CreateTagResult = NonNullable<Awaited<ReturnType<typeof createTag>>>
export type FindTagByIdResult = NonNullable<Awaited<ReturnType<typeof findTagById>>>
export type UpdateTagResult = NonNullable<Awaited<ReturnType<typeof updateTag>>>
export type DeleteTagResult = NonNullable<Awaited<ReturnType<typeof deleteTag>>>
export type ListImagesResult = NonNullable<Awaited<ReturnType<typeof listImages>>>
export type CreateImageResult = NonNullable<Awaited<ReturnType<typeof createImage>>>
export type FindImageByIdResult = NonNullable<Awaited<ReturnType<typeof findImageById>>>
export type UpdateImageResult = NonNullable<Awaited<ReturnType<typeof updateImage>>>
export type DeleteImageResult = NonNullable<Awaited<ReturnType<typeof deleteImage>>>
export type ListModelsResult = NonNullable<Awaited<ReturnType<typeof listModels>>>
export type CreateModelResult = NonNullable<Awaited<ReturnType<typeof createModel>>>
export type FindModelByIdResult = NonNullable<Awaited<ReturnType<typeof findModelById>>>
export type UpdateModelResult = NonNullable<Awaited<ReturnType<typeof updateModel>>>
export type DeleteModelResult = NonNullable<Awaited<ReturnType<typeof deleteModel>>>
export type ListIconsResult = NonNullable<Awaited<ReturnType<typeof listIcons>>>
export type CreateIconResult = NonNullable<Awaited<ReturnType<typeof createIcon>>>
export type FindIconByIdResult = NonNullable<Awaited<ReturnType<typeof findIconById>>>
export type UpdateIconResult = NonNullable<Awaited<ReturnType<typeof updateIcon>>>
export type DeleteIconResult = NonNullable<Awaited<ReturnType<typeof deleteIcon>>>
export type ListStatsResult = NonNullable<Awaited<ReturnType<typeof listStats>>>
export type CreateStatsResult = NonNullable<Awaited<ReturnType<typeof createStats>>>
export type FindStatsByIdResult = NonNullable<Awaited<ReturnType<typeof findStatsById>>>
export type UpdateStatsResult = NonNullable<Awaited<ReturnType<typeof updateStats>>>
export type DeleteStatsResult = NonNullable<Awaited<ReturnType<typeof deleteStats>>>
export type ListPhotosResult = NonNullable<Awaited<ReturnType<typeof listPhotos>>>
export type CreatePhotoResult = NonNullable<Awaited<ReturnType<typeof createPhoto>>>
export type FindPhotoByIdResult = NonNullable<Awaited<ReturnType<typeof findPhotoById>>>
export type UpdatePhotoResult = NonNullable<Awaited<ReturnType<typeof updatePhoto>>>
export type DeletePhotoResult = NonNullable<Awaited<ReturnType<typeof deletePhoto>>>
export type ListMembersResult = NonNullable<Awaited<ReturnType<typeof listMembers>>>
export type CreateMemberResult = NonNullable<Awaited<ReturnType<typeof createMember>>>
export type FindMemberByIdResult = NonNullable<Awaited<ReturnType<typeof findMemberById>>>
export type UpdateMemberResult = NonNullable<Awaited<ReturnType<typeof updateMember>>>
export type DeleteMemberResult = NonNullable<Awaited<ReturnType<typeof deleteMember>>>
export type ListTokenUtilitiesResult = NonNullable<Awaited<ReturnType<typeof listTokenUtilities>>>
export type CreateTokenUtilityResult = NonNullable<Awaited<ReturnType<typeof createTokenUtility>>>
export type FindTokenUtilityByIdResult = NonNullable<Awaited<ReturnType<typeof findTokenUtilityById>>>
export type UpdateTokenUtilityResult = NonNullable<Awaited<ReturnType<typeof updateTokenUtility>>>
export type DeleteTokenUtilityResult = NonNullable<Awaited<ReturnType<typeof deleteTokenUtility>>>
export type ListPremiumSubscriptionsResult = NonNullable<Awaited<ReturnType<typeof listPremiumSubscriptions>>>
export type CreatePremiumSubscriptionResult = NonNullable<Awaited<ReturnType<typeof createPremiumSubscription>>>
export type FindPremiumSubscriptionByIdResult = NonNullable<Awaited<ReturnType<typeof findPremiumSubscriptionById>>>
export type UpdatePremiumSubscriptionResult = NonNullable<Awaited<ReturnType<typeof updatePremiumSubscription>>>
export type DeletePremiumSubscriptionResult = NonNullable<Awaited<ReturnType<typeof deletePremiumSubscription>>>
export type ListPayloadKvsResult = NonNullable<Awaited<ReturnType<typeof listPayloadKvs>>>
export type CreatePayloadKvResult = NonNullable<Awaited<ReturnType<typeof createPayloadKv>>>
export type FindPayloadKvByIdResult = NonNullable<Awaited<ReturnType<typeof findPayloadKvById>>>
export type UpdatePayloadKvResult = NonNullable<Awaited<ReturnType<typeof updatePayloadKv>>>
export type DeletePayloadKvResult = NonNullable<Awaited<ReturnType<typeof deletePayloadKv>>>
export type ListPayloadLockedDocumentsResult = NonNullable<Awaited<ReturnType<typeof listPayloadLockedDocuments>>>
export type CreatePayloadLockedDocumentResult = NonNullable<Awaited<ReturnType<typeof createPayloadLockedDocument>>>
export type FindPayloadLockedDocumentByIdResult = NonNullable<Awaited<ReturnType<typeof findPayloadLockedDocumentById>>>
export type UpdatePayloadLockedDocumentResult = NonNullable<Awaited<ReturnType<typeof updatePayloadLockedDocument>>>
export type DeletePayloadLockedDocumentResult = NonNullable<Awaited<ReturnType<typeof deletePayloadLockedDocument>>>
export type ListPayloadPreferencesResult = NonNullable<Awaited<ReturnType<typeof listPayloadPreferences>>>
export type CreatePayloadPreferenceResult = NonNullable<Awaited<ReturnType<typeof createPayloadPreference>>>
export type FindPayloadPreferenceByIdResult = NonNullable<Awaited<ReturnType<typeof findPayloadPreferenceById>>>
export type UpdatePayloadPreferenceResult = NonNullable<Awaited<ReturnType<typeof updatePayloadPreference>>>
export type DeletePayloadPreferenceResult = NonNullable<Awaited<ReturnType<typeof deletePayloadPreference>>>
export type ListPayloadMigrationsResult = NonNullable<Awaited<ReturnType<typeof listPayloadMigrations>>>
export type CreatePayloadMigrationResult = NonNullable<Awaited<ReturnType<typeof createPayloadMigration>>>
export type FindPayloadMigrationByIdResult = NonNullable<Awaited<ReturnType<typeof findPayloadMigrationById>>>
export type UpdatePayloadMigrationResult = NonNullable<Awaited<ReturnType<typeof updatePayloadMigration>>>
export type DeletePayloadMigrationResult = NonNullable<Awaited<ReturnType<typeof deletePayloadMigration>>>
export type GetApiGlobalsSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiGlobalsSettings>>>
export type PostApiGlobalsSettingsResult = NonNullable<Awaited<ReturnType<typeof postApiGlobalsSettings>>>
